module.exports = __webpack_public_path__ + "img/shop-empty.2c234f96.png";